import { tw } from 'utils/classnames'

interface CardContentProps extends React.ComponentProps<'div'> {
  children: React.ReactNode
  className?: string
}

export const CardContent = (props: CardContentProps) => {
  return (
    <div {...props} className={tw(props.className, 'mt-2')}>
      {props.children}
    </div>
  )
}
